
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ParaVosSi from './components/ParaVosSi';
import QueTeLlevas from './components/QueTeLlevas';
import PracticarEnVivo from './components/PracticarEnVivo';
import Programa from './components/Programa';
import ComoSeDa from './components/ComoSeDa';
import QuienesLoDan from './components/QuienesLoDan';
import Testimonios from './components/Testimonios';
import EntradasYPacks from './components/EntradasYPacks';
import ComoReservar from './components/ComoReservar';
import PreguntasFrecuentes from './components/PreguntasFrecuentes';
import FooterSection from './components/FooterSection';
import CuposBar from '../../components/feature/CuposBar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <Navbar />
      <HeroSection />
      <ParaVosSi />
      <QueTeLlevas />
      <PracticarEnVivo />
      <Programa />
      <ComoSeDa />
      <QuienesLoDan />
      <Testimonios />
      <EntradasYPacks />
      <ComoReservar />
      <PreguntasFrecuentes />
      <FooterSection />
      <CuposBar />
    </div>
  );
}
